import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";
import { getColor } from "../../brandConfig";
const PokerCoach = React.lazy(() => import("./PokerCoach"));
const ResultsDashboard = React.lazy(() => import("./ResultsDashboard"));
const StrategyGuide = React.lazy(() => import("./StrategyGuide"));
const config: ModuleConfig = {
  id: "poker-coach",
  name: "Poker Coach",
  description:
    "Position coaching, public Block52 table updates and replay practice.",
  version: "0.3.0",
  enabled: true,
  category: "communication",
  order: 13,
  icon: "🃏",
  color: getColor("primary"),
  permissions: { view: [], create: [], edit: [], delete: [] },
  navigation: [
    { label: "Results & money", path: "/poker-coach/results", icon: "📊", permissionLevel: "view" },
    {
      label: "Poker Coach",
      path: "/poker-coach",
      icon: "🃏",
      permissionLevel: "view",
    },
    {
      label: "Position & strategy",
      path: "/poker-coach/strategy",
      icon: "📖",
      permissionLevel: "view",
    },
  ],
  routes: [
    { path: "/poker-coach/results", component: ResultsDashboard, permissionLevel: "view", useLayout: true },
    {
      path: "/poker-coach",
      component: PokerCoach,
      permissionLevel: "view",
      useLayout: true,
    },
    {
      path: "/poker-coach/strategy",
      component: StrategyGuide,
      permissionLevel: "view",
      useLayout: true,
    },
  ],
};
export default config;
